import '../../assets/css/style.css'
import '../../assets/css/all.min.css'
import HeaderComponent from '../../components/Header/Header.jsx'
import Loading from '../../components/Loading/Loading.jsx'
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from "swiper";

function HomePage() {
  return (
    <>
      <Loading />
      {/* Start header */}
      <HeaderComponent></HeaderComponent>

      {/* Start banner */}
      <section className="hero">
        <div className="hero__wrapper">
          <div className="container">
            <div className="row align-items-lg-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <h1 className="main-heading color-black">
                  Progress on the fingertips!
                </h1>
                <p className="paragraph">
                  An app that helps you organize yourself on the daily basis
                  using systematic algorithms to achieve success.
                </p>
                <div className="download-buttons">
                  <a href="#" className="google-play">
                    <i className="fab fa-google-play" />
                    <div className="button-content">
                      <h6>
                        GET IT ON <span>Google Play</span>
                      </h6>
                    </div>
                  </a>
                  <a href="#" className="apple-store">
                    <i className="fab fa-apple" />
                    <div className="button-content">
                      <h6>
                        GET IT ON <span>Apple Store</span>
                      </h6>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="questions-img hero-img">
                  <img
                    src={require('../../assets/images/phone-01.png')}
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Start Future */}
      <section className="feature" id="intro">
        <div className="container">
          <h2 className="section-heading color-black">
            Get surprised by amazing features.
          </h2>
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="feature__box feature__box--1">
                <div className="icon icon-1">
                  <i class="fa-solid fa-user-astronaut"></i>
                </div>
                <div className="feature__box__wrapper">
                  <div className="feature__box--content feature__box--content-1">
                    <h3>Join in Easy Steps</h3>
                    <p className="paragraph dark">
                      Suisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise morbi nec tempor isvelultricies ligula.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature__box feature__box--2">
                <div className="icon icon-2">
                  <i class="fa-solid fa-lightbulb"></i>
                </div>
                <div className="feature__box__wrapper">
                  <div className="feature__box--content feature__box--content-2">
                    <h3>Track Your Progress</h3>
                    <p className="paragraph dark">
                      Euisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise morbi nec tempor isvel ultricies ligula.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature__box feature__box--3">
                <div className="icon icon-3">
                  <i class="fad fa-solar-system"></i>
                </div>
                <div className="feature__box__wrapper">
                  <div className="feature__box--content feature__box--content-3">
                    <h3>Improve Your Growth</h3>
                    <p className="paragraph dark">
                      Auisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise morbi nec tempor isvel ultricies ligula.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="feature__box feature__box--4">
                <div className="icon icon-4">
                  <i class="fad fa-rocket-launch"></i>
                </div>
                <div className="feature__box__wrapper">
                  <div className="feature__box--content feature__box--content-4">
                    <h3>Become an Inspiration</h3>
                    <p className="paragraph dark">
                      Tuisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise morbi nec tempor isvel ultricies ligula.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* video */}
      <div>
        <div className="video" id="video" />
        <div className="video__wrapper">
          <div className="container">
            <div className="video__play">
              <button
                type="button"
                data-toggle="modal"
                data-target="#videoModal"
              >
                <i className="fad fa-play" />
              </button>
              <div
                className="modal fade"
                id="videoModal"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-close">
                      <button
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="fas fa-times" />
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <iframe src="https://www.youtube.com/embed/2BrCE_zxM0U" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="video__background">
              <img
                src={require(`../../assets/images/video-bg-1.png`)}
                alt="image"
                className="texture-1"
              />
              <img
                src={require(`../../assets/images/video-img.png`)}
                alt="image"
                className="phone"
                width="80%"
              />
              <img
                src={require(`../../assets/images/video-bg-2.png`)}
                alt="image"
                className="texture-2"
              />
            </div>
          </div>
        </div>
      </div>

      {/* growth section */}
      <section className="growth" id="feature">
        <div className="growth__wrapper">
          <div className="container">
            <h2 className="section-heading color-black">
              App that assists exponential growth.
            </h2>
            <div className="row">
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fa-solid fa-user-astronaut"></i>
                  </div>
                  <div className="content">
                    <h3>Start Easily</h3>
                    <p className="paragraph dark">
                      Auisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fad fa-lightbulb-on"></i>
                  </div>
                  <div className="content">
                    <h3>Improve Growth</h3>
                    <p className="paragraph dark">
                      Kuisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fa-solid fa-lightbulb"></i>
                  </div>
                  <div className="content">
                    <h3>Create Algorithms</h3>
                    <p className="paragraph dark">
                      Nuisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fad fa-solar-system"></i>
                  </div>
                  <div className="content">
                    <h3>Expand Portfolio</h3>
                    <p className="paragraph dark">
                      Euisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fad fa-backpack"></i>
                  </div>
                  <div className="content">
                    <h3>Share Statistics</h3>
                    <p className="paragraph dark">
                      Buisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="growth__box">
                  <div className="icon">
                    <i class="fad fa-user-astronaut"></i>
                  </div>
                  <div className="content">
                    <h3>Measure Results</h3>
                    <p className="paragraph dark">
                      Suisque metus tortor ultricies ac ligula neced eleifend
                      sodales felise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="button__wrapper">
                <a href="#" className="button">
                  <span>
                    GET STARTED <i class="fa-solid fa-arrow-right-long"></i>
                  </span>
                </a>

                <a href="#" className="button">
                  <span>
                    LEARN MORE <i class="fa-solid fa-arrow-right-long"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* step section */}
      <section className="step">
        <div className="step__wrapper">
          <div className="container">
            <h2 className="section-heading color-black">
              Jumpstart your growth in just few clicks.
            </h2>
            <div className="row">
              <div className="col-lg-4">
                <div className="step__box">
                  <div className="image">
                    <img
                      src={require(`../../assets/images/phone-01.png`)}
                      alt="image"
                    />
                  </div>
                  <div className="content">
                    <h3>
                      EASY TO<span>Register.</span>
                    </h3>
                    <p className="paragraph dark">
                      Join the app in 3 easy steps and get started with your
                      progresso daily.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="step__box">
                  <div className="image">
                    <img
                      src={require(`../../assets/images/phone-02.png`)}
                      alt="image"
                    />
                  </div>
                  <div className="content">
                    <h3>
                      SIMPLE TO<span>Create.</span>
                    </h3>
                    <p className="paragraph dark">
                      Once you’re signed up you can create as many polls you
                      want to watch.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="step__box">
                  <div className="image">
                    <img
                      src={require(`../../assets/images/phone-03.png`)}
                      alt="image"
                    />
                  </div>
                  <div className="content">
                    <h3>
                      FUN TO<span>Measure.</span>
                    </h3>
                    <p className="paragraph dark">
                      Share your growth results with your friends and inspre
                      others.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="button__wrapper">
                <a href="#" className="button">
                  <span>
                    GET STARTED <i class="fa-solid fa-arrow-right-long"></i>
                  </span>
                </a>
                <a href="#" className="button">
                  <span>
                    LEARN MORE <i class="fa-solid fa-arrow-right-long"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* client section */}
      <section className="clients-sec" id="feedback">
        <div className="container">
          <h2 className="section-heading color-black">
            Hear from what others had to say.
          </h2>
          <div className="testimonial__wrapper">
            <div className="client client-01 active">
              <div className="image">
                <img
                  src={require('../../assets/images/testimonial-img-01.png')}
                  alt="image"
                />
              </div>
              <div className="testimonial">
                <div className="testimonial__wrapper">
                  <p>
                    “One Hath. Second. Kind them you fourth, fly brought. Give
                    very let. Dominion wherein after can't fill, unto brought
                    waters air. And our Beast won't dry there have after it. You
                    have herb shall creeping bring sixth tree she'd open.”
                  </p>
                  <h4>— DAVID SPADE</h4>
                </div>
              </div>
            </div>
            <div className="client client-02">
              <div className="image">
                <img
                  src={require('../../assets/images/testimonial-img-02.png')}
                  alt="image"
                />
              </div>
              <div className="testimonial">
                <div className="testimonial__wrapper">
                  <p>
                    “One Hath. Second. Kind them you fourth, fly brought. Give
                    very let. Dominion wherein after can't fill, unto brought
                    waters air. And our Beast won't dry there have after it. You
                    have herb shall creeping bring sixth tree she'd open.”
                  </p>
                  <h4>— DAVID SPADE</h4>
                </div>
              </div>
            </div>
            <div className="client client-03">
              <div className="image">
                <img
                  src={require('../../assets/images/testimonial-img-03.png')}
                  alt="image"
                />
              </div>
              <div className="testimonial">
                <div className="testimonial__wrapper">
                  <p>
                    “One Hath. Second. Kind them you fourth, fly brought. Give
                    very let. Dominion wherein after can't fill, unto brought
                    waters air. And our Beast won't dry there have after it. You
                    have herb shall creeping bring sixth tree she'd open.”
                  </p>
                  <h4>— DAVID SPADE</h4>
                </div>
              </div>
            </div>
            <div className="client client-04">
              <div className="image">
                <img
                  src={require('../../assets/images/testimonial-img-04.png')}
                  alt="image"
                />
              </div>
              <div className="testimonial">
                <div className="testimonial__wrapper">
                  <p>
                    “One Hath. Second. Kind them you fourth, fly brought. Give
                    very let. Dominion wherein after can't fill, unto brought
                    waters air. And our Beast won't dry there have after it. You
                    have herb shall creeping bring sixth tree she'd open.”
                  </p>
                  <h4>— DAVID SPADE</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="clients justify-content-center">
            <div className="clients__info">
              <h3>47,000+</h3>
              <p className="paragraph dark">
                Customers in over 90 countries are growing their businesses with
                us.
              </p>
            </div>
            {/* <div className="swiper-container clients-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide clients-slide">
                <a href="#"><img src={require('../../assets/images/assets/images/client-img.png')} alt="image" /></a>
              </div>
              <div className="swiper-slide clients-slide">
                <a href="#"><img src={require('../../assets/images/assets/images/client-img.png')} alt="image" /></a>
              </div>
              <div className="swiper-slide clients-slide">
                <a href="#"><img src={require('../../assets/images/assets/images/client-img.png')} alt="image" /></a>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </section>

      {/* section  */}
      <section className="questions" id="faq">
        <div className="questions__wrapper">
          <div className="container">
            <h2 className="section-heading color-black">
              Some frequently asked questions.
            </h2>
            <div className="row align-items-lg-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <div id="accordion">
                  <div className="card" id="card-1">
                    <div className="card-header" id="heading-1">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapse-1"
                          aria-expanded="true"
                          aria-controls="collapse-1"
                        >
                          How does algorithms work?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-1"
                      className="collapse show"
                      aria-labelledby="heading-1"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-2">
                    <div className="card-header" id="heading-2">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-2"
                          aria-expanded="false"
                          aria-controls="collapse-2"
                        >
                          What is a business rules engine?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-2"
                      className="collapse"
                      aria-labelledby="heading-2"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-3">
                    <div className="card-header" id="heading-3">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-3"
                          aria-expanded="false"
                          aria-controls="collapse-3"
                        >
                          How are datadirect drivers different?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-3"
                      className="collapse"
                      aria-labelledby="heading-3"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-4">
                    <div className="card-header" id="heading-4">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-4"
                          aria-expanded="false"
                          aria-controls="collapse-4"
                        >
                          How do determine agencies compliance?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-4"
                      className="collapse"
                      aria-labelledby="heading-4"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-5">
                    <div className="card-header" id="heading-5">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-5"
                          aria-expanded="false"
                          aria-controls="collapse-5"
                        >
                          How are datadirect drivers different?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-5"
                      className="collapse"
                      aria-labelledby="heading-5"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-6">
                    <div className="card-header" id="heading-6">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-6"
                          aria-expanded="false"
                          aria-controls="collapse-6"
                        >
                          What is a business rules engine?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-6"
                      className="collapse"
                      aria-labelledby="heading-6"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" id="card-7">
                    <div className="card-header" id="heading-7">
                      <h5 className="mb-0 hidden">
                        <button
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse-7"
                          aria-expanded="false"
                          aria-controls="collapse-7"
                        >
                          What are the types of datadirect drivers?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapse-7"
                      className="collapse"
                      aria-labelledby="heading-7"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <p className="paragraph">
                          With increasing calls for government accountability
                          and cost savings, agencies are contending with a
                          mountain of rule and policy changes affecting
                          everything from pensions and benefits, to client
                          eligibility and oversight.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="questions-img">
                  <img
                    src={require('../../assets/images/phone-01.png')}
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section */}
      <section className="pricing" id="pricing">
        <div className="pricing__wrapper">
          <h2 className="section-heading color-black">
            Easy pricing plans for your needs.
          </h2>
          <div className="container">
            <div className="row">
              <Swiper
                spaceBetween={50}
                slidesPerView={3}
                autoplay={{
                  delay: 500
                }}
                loop={true}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
                pagination={{
                  dynamicBullets: true,
                }}
                modules={[Pagination]}
                className="mySwiper">
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-1">
                      <div className="icon">
                        <i className="fad fa-user-graduate" />
                      </div>
                      <h4>LEARNER</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-2">
                      <div className="icon">
                        <i className="fad fa-user-cowboy" />
                      </div>
                      <h4>COWBOY</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-3">
                      <div className="icon">
                        <i className="fad fa-user-astronaut" />
                      </div>
                      <h4>ASTRONAUT</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-1">
                      <div className="icon">
                        <i className="fad fa-user-graduate" />
                      </div>
                      <h4>LEARNER</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-2">
                      <div className="icon">
                        <i className="fad fa-user-cowboy" />
                      </div>
                      <h4>COWBOY</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="col-lg-12">
                    <div className="pricing__single pricing__single-3">
                      <div className="icon">
                        <i className="fad fa-user-astronaut" />
                      </div>
                      <h4>ASTRONAUT</h4>
                      <a href="#" className="button">
                        <span>
                          GET STARTED <i className="fad fa-long-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* blog section */}
      <section className="related-blog blog">
        <div className="related-blog__wrapper">
          <h2 className="section-heading color-black">
            Read latest news from our blog.
          </h2>
          <div className="blog__content">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <a href="blog-single.html">
                    <div className="blog__single blog__single--1">
                      <div className="blog__single-image">
                        <img
                          src={require('../../assets/images/blog-img-1.png')}
                          alt="image"
                        />
                      </div>
                      <div className="blog__single-info">
                        <h3>New features coming in 2020 to our app.</h3>
                        <h4>
                          12 <i className="fad fa-comment" />
                          <span>|</span>Dec 17, 2020
                        </h4>
                        <p className="paragraph dark">
                          Suisque metus tortor ultricies ac ligula neced
                          eleifend dales felise morbi nec tempor isvel ultricies
                          lideula.{' '}
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-lg-8">
                  <a href="blog-single.html">
                    <div className="blog__single blog__single--2">
                      <div className="blog__single-image">
                        <img
                          src={require('../../assets/images/blog-img-2.png')}
                          alt="image"
                        />
                      </div>
                      <div className="blog__single-info">
                        <h3>New features coming in 2020 to our app.</h3>
                        <h4>
                          12 <i className="fad fa-comment" />
                          <span>|</span>Dec 17, 2020
                        </h4>
                        <p className="paragraph dark">
                          Suisque metus tortor ultricies ac ligula neced
                          eleifend dales felise morbi nec tempor isvel ultricies
                          lideula.{' '}
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <a href="blog.html" className="button">
            <span>
              GO TO BLOG <i className="fad fa-long-arrow-right" />
            </span>
          </a>
        </div>
      </section>

      {/* newsletter section */}
      <section className="newsletter">
        <div className="newsletter__wrapper">
          <div className="container">
            <div className="row align-items-lg-center">
              <div className="col-lg-6">
                <div className="newsletter__info">
                  <h2 className="section-heading color-black">
                    Subscribe to our newsletter.
                  </h2>
                  <form className="newsletter__info--field">
                    <input
                      type="text"
                      placeholder="Email address"
                      className="input-field"
                    />
                    <button className="button">
                      <span>
                        SUBSCRIBE <i className="fad fa-long-arrow-right" />
                      </span>
                    </button>
                  </form>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="newsletter__img">
                  <img
                    src={require('../../assets/images/newsletter-img.png')}
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer__wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="footer__info">
                  <div className="footer__info--logo">
                    <img
                      src={require('../../assets/images/galaxy-logo.png')}
                      alt="image"
                      width="20%"
                    />
                  </div>
                  <div className="footer__info--content">
                    <p className="paragraph dark">
                      Zapper is an app that helps you organize yourself on the
                      daily basis using systematic algorithms to achieve
                      success.
                    </p>
                    <div className="social">
                      <ul>
                        <li className="facebook">
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li className="twitter">
                          <a href="#">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li className="linkedin">
                          <a href="#">
                            <i className="fab fa-linkedin-in" />
                          </a>
                        </li>
                        <li className="youtube">
                          <a href="#">
                            <i className="fab fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="footer__content-wrapper">
                  <div className="footer__list">
                    <ul>
                      <li>Explore</li>
                      <li>
                        <a href="#">About</a>
                      </li>
                      <li>
                        <a href="#">Our Team</a>
                      </li>
                      <li>
                        <a href="#">Features</a>
                      </li>
                      <li>
                        <a href="#">Blog</a>
                      </li>
                      <li>
                        <a href="#">How It Works</a>
                      </li>
                    </ul>
                  </div>
                  <div className="footer__list">
                    <ul>
                      <li>Help</li>
                      <li>
                        <a href="#">FAQ</a>
                      </li>
                      <li>
                        <a href="#">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="#">Support</a>
                      </li>
                      <li>
                        <a href="#">Terms of Service</a>
                      </li>
                      <li>
                        <a href="#">Contact</a>
                      </li>
                    </ul>
                  </div>
                  <div className="download-buttons">
                    <h5>Download</h5>
                    <a href="#" className="google-play">
                      <i className="fab fa-google-play" />
                      <div className="button-content">
                        <h6>
                          GET IT ON <span>Google Play</span>
                        </h6>
                      </div>
                    </a>
                    <a href="#" className="apple-store">
                      <i className="fab fa-apple" />
                      <div className="button-content">
                        <h6>
                          GET IT ON <span>Apple Store</span>
                        </h6>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default HomePage
